export const ITR_flushAPICallsDataReducer = {
  ITR_flushAPICallsData: (state, action) => {
    state.saveBsDocUploadAPICall = {
      response: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
  },
};
